import {Component, Input} from '@angular/core';
import {CommonModule} from "@angular/common";
import {DocumentSummaryModel} from "../../model/documentSummary.model";
import {DownloadButtonModule} from "../../../../../core/component/download-button/download-button.module";
import {DocumentDownloadModule} from "../document-download/document-download.module";

@Component({
  selector: 'app-document-download-link',
  templateUrl: './document-download-link.component.html',
  standalone: true,
  imports: [
    CommonModule,
    DownloadButtonModule,
    DocumentDownloadModule,
  ]
})
export class DocumentDownloadLinkComponent {

  @Input() entity: DocumentSummaryModel;

  download() {

  }
}
